import { gql } from '@apollo/client';

export const SETTINGS_BLUEPRINTS_QUERY = gql`
  query SettingsBlueprints($limit: Int, $name: String, $lastEvaluatedKey: String, $code: String) {
    operativeViewer {
      settingsBlueprints(limit: $limit, name: $name, lastEvaluatedKey: $lastEvaluatedKey, code: $code) {
        lastEvaluatedKey
        items {
          id
          createdAt
          name
          storage
          companyId
        }
      }
    }
  }
`;
